import { useMemo } from 'react';
import { GROUPBY } from '../../../../constants/Reports';
import { calculateFooter } from './useFooterCalculation';

export const useStipendsSORows = (raw, columns, groupby) =>
  useMemo(() => {
    const source = (raw && raw.data) || raw;
    if (!source || typeof source !== 'object') return [];

    return Object.entries(source).map(([groupTitle, rows]) => {
      const items = (rows || []).map((arrRow, rowIndex) => {
        if (groupby === GROUPBY[0].value) {
          const [date, shift, description, amount] = arrRow;
          return { id: rowIndex, date, shift, amount, description };
        }
        if (groupby === GROUPBY[1].value) {
          const [employee, shift, description, amount] = arrRow;
          return { id: rowIndex, employee, shift, amount, description };
        }

        const rowObject = { id: rowIndex };
        (arrRow || []).forEach((value, i) => {
          rowObject[`col${i}`] = value;
        });
        return rowObject;
      });

      const footer = calculateFooter(items, columns, true);

      return {
        name: groupTitle,
        items,
        footer,
      };
    });
  }, [raw, columns, groupby]);
